import { create } from 'zustand';

// Single store to manage all geometry selections
export const useGeometrySelectionStore = create((set, get) => ({
  // Current selected geometry type and ID
  selectedType: null, // 'background' | 'parcel' | 'building' | 'topography' | null
  selectedId: null, // ID of the selected geometry (useful if you have multiple buildings, etc.)
  
  // Select a geometry - automatically deselects others
  selectGeometry: (type, id = null) => {
    set({ 
      selectedType: type, 
      selectedId: id 
    });
  },
  
  // Clear all selections
  clearSelection: () => {
    set({ 
      selectedType: null, 
      selectedId: null 
    });
  },
  
  // Check if a specific geometry type is selected
  isSelected: (type, id = null) => {
    const state = get();
    if (id !== null) {
      return state.selectedType === type && state.selectedId === id;
    }
    return state.selectedType === type;
  },
  
  // Helper methods for each geometry type
  selectBackground: () => set({ selectedType: 'background', selectedId: null }),
  selectParcel: (id = null) => set({ selectedType: 'parcel', selectedId: id }),
  selectBuilding: (id = null) => set({ selectedType: 'building', selectedId: id }),
  selectTopography: (id = null) => set({ selectedType: 'topography', selectedId: id }),
  
  // Getters
  isBackgroundSelected: () => get().selectedType === 'background',
  isParcelSelected: (id = null) => {
    const state = get();
    return id !== null 
      ? state.selectedType === 'parcel' && state.selectedId === id
      : state.selectedType === 'parcel';
  },
  isBuildingSelected: (id = null) => {
    const state = get();
    return id !== null 
      ? state.selectedType === 'building' && state.selectedId === id
      : state.selectedType === 'building';
  },
  isTopographySelected: (id = null) => {
    const state = get();
    return id !== null 
      ? state.selectedType === 'topography' && state.selectedId === id
      : state.selectedType === 'topography';
  },
}));

// Example usage in your React Three Fiber scene component
